import React from "react";
import { useLocation } from "react-router-dom";
import { Phone, Mail } from "lucide-react";

const PHONE = "(916) 678-0058";
const PHONE_TEL = "+19166780058";
const EMAIL = "acquisitions@brightsidecapital.net";

const HIDE_ON = ["/start", "/admin", "/thank-you"];

export default function ContactBar() {
  const location = useLocation();
  if (HIDE_ON.some((p) => location.pathname.startsWith(p))) return null;
  return (
    <div className="contact-bar bg-[#0A0A0A] border-y border-white/10 text-neutral-300 text-sm" data-testid="contact-bar">
      <div className="max-w-7xl mx-auto px-5 md:px-8 lg:px-12 py-4 text-center space-y-2">
        <div className="text-[11px] uppercase tracking-widest text-[#C19B6C] font-semibold">
          Call or text now for fastest response
        </div>
        <div className="flex flex-wrap items-center justify-center gap-x-8 gap-y-2">
          <a
            href={`tel:${PHONE_TEL}`}
            className="inline-flex items-center gap-2 text-white hover:text-[#C19B6C] transition-colors"
            data-testid="contact-bar-call"
          >
            <Phone size={16} className="text-[#C19B6C]" />
            <span className="font-bold text-base">{PHONE}</span>
          </a>
          <span className="hidden md:inline text-neutral-700">·</span>
          <a
            href={`mailto:${EMAIL}`}
            className="inline-flex items-center gap-2 hover:text-[#C19B6C] transition-colors"
            data-testid="contact-bar-email"
          >
            <Mail size={14} className="text-[#C19B6C]" />
            <span className="text-white">{EMAIL}</span>
          </a>
        </div>
        <div className="text-[11px] text-neutral-500 italic">Direct line, not a call center</div>
      </div>
    </div>
  );
}
